import React from 'react';
import PropTypes from 'prop-types';
import enValues from './en';

export const LocalizationContext = React.createContext({ en: enValues });

export const LocalizationConsumer = ({ id }) => (
  <LocalizationContext.Consumer>{({ en }) => en[id] }</LocalizationContext.Consumer>
);

LocalizationConsumer.propTypes = {
  id: PropTypes.string.isRequired
};

export const LocalizationOption = ({ id, ...otherProps }) => (
  <LocalizationContext.Consumer>
    {
      ({ en }) => (<option {...otherProps}>{en[id]}</option>)
    }
  </LocalizationContext.Consumer>
);

LocalizationOption.propTypes = {
  id: PropTypes.string.isRequired
};

export default LocalizationConsumer;